import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLoadingCorporation: false,
  isLoadingCustomers: false,
  corporations: [],
  customers: [],
  selectedCorporation: null,
  selectedCustomers: [],
  page: 1,
  totalPages: 0,
  corporationError: null,
};

export const corporationSlice = createSlice({
  name: "corporation",
  initialState,
  reducers: {
    setSelectedCorporation: (state, { payload }) => {
      state.selectedCorporation = payload;
    },
    setSelectedCustomers: (state, { payload }) => {
      state.selectedCustomers.push(payload);
    },
    setCustomers: (state, { payload }) => {
      state.customers = payload;
    },
    setLoadingCustomers: (state, { payload }) => {
      state.isLoadingCustomers = payload;
    },
    setLoadingCorporation: (state, { payload }) => {
      state.isLoadingCorporation = payload;
    },
    loadCorporations: (state, action) => {
      state.corporations = action.payload.result;
      state.page = action.payload.page;
      state.totalPages = action.payload.totalPages;
    },
    search: (state, { payload }) => {
      state.isLoadingCorporation = true;
      state.page = 1;
      state.corporations = payload;
    },
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setCorporationError: (state, { payload }) => {
      state.corporationError = payload;
    },
    updateCorporation: (state, { payload }) => {
      const { id, name } = payload;

      state.corporations = state.corporations.map((corporation) =>
        corporation.id === id ? { ...corporation, name } : corporation
      );

      if (state.selectedCorporation?.corporation?.id === id) {
        state.selectedCorporation.corporation.name = name;
      }
    },
    updateCorporationAdmin: (state, { payload }) => {
      const { customer } = payload;

      if (!state.selectedCorporation?.members || !customer) {
        return;
      }

      const existingMemberIndex = state.selectedCorporation.members.findIndex(
        (member) => member.customerId === customer.id
      );

      state.selectedCorporation.members =
        state.selectedCorporation.members.map((member) => ({
          ...member,
          isAdmin: false,
        }));

      if (existingMemberIndex >= 0) {
        state.selectedCorporation.members[existingMemberIndex].isAdmin = true;
        return;
      }

      state.selectedCorporation.members.push({
        customerId: customer.id,
        customerIdentification: customer.identification,
        customerName: customer.name,
        isAdmin: true,
        status: true,
      });
    },
    deleteCorporation: (state, { payload }) => {
      const corporationId = Number(payload);

      state.corporations = state.corporations.filter(
        (corporation) => Number(corporation.id) !== corporationId
      );

      if (
        Number(state.selectedCorporation?.corporation?.id) === corporationId
      ) {
        state.selectedCorporation = null;
      }
    },
    clearSelectedCustomers: (state) => {
      state.selectedCustomers = [];
    },
    clearCorporations: (state) => {
      state.corporations = [];
    },
    clearSelectedCorporation: (state) => {
      state.selectedCorporation = null;
    },
    removeSelectedCustomer: (state, { payload }) => {
      state.selectedCustomers = state.selectedCustomers.filter(
        (customer) => customer.id !== payload
      );
    },
  },
});
export const corporationActions = corporationSlice.actions;

export default corporationSlice.reducer;
